// import RootStore from 'stores/RootStore';
import RootStore from "stores/RootStore";
import ServiceStore from "stores/ServiceStore";
import type { RouteType } from "types/RouteType";
// import IFCTrackerLeftHeaderCell from './IFCTracker.LeftHeaderCell';
// import IFCTrackerRightHeaderCell from './IFCTracker.RightHeaderCell';

// import * as utils from '@intrasync/utils';
// import * as utils from '@intrasync/utils';
// // import IFCTrackerIcon from '@mui/icons-material/GridOn';
// import { toJS } from 'mobx';
// import IFCTrackerStore from 'stores/IFCTrackerStore';
// import ServiceStore from 'stores/ServiceStore';

const ifcTrackerRoute: RouteType[] = [
  {
    name: "Drawing Tracker",
    path: "/job/:jobNumber/ifc-tracker",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Drawing Tracker",
        // component: () => import('./IFCTracker.Header'), // Assuming a header component exists
        enableToolbox: true,
        enableBackButton: true,
        enableRefreshButton: true,
      },
      body: {
        // component: () => import('./IFCTracker.Body'), // Assuming a body component exists
        scheduleContainer: {
          namespace: "IFCTracker",
          storeName: "ifcTrackerStore",
          dateKey: "castingDate",
          dateRangeKey: "trackerDateRange",
          fixedRowCount: 1,
          // height: 500,
          // width: 500,
          // columnHeaders: [
          //   {
          //     width: 200,
          //     title: 'Date',
          //     key: 'castingDate',
          //     component: IFCTrackerLeftHeaderCell,
          //   },
          //   {
          //     width: 200,
          //     title: 'Date',
          //     key: 'castingDate',
          //     component: IFCTrackerRightHeaderCell,
          //   },
          // ],
        },
      },
    },
    group: 'Inventory & Field',
  requiresAuth: true, // Assuming it requires authentication since it requires permission
    requiresPermission: false,
    permissionPath: "/app/ifc-tracker", // Maintaining permission path for consistency
    // defaultQueryParams: {
    //   productType: `job-stats/panel-count/:jobNumber.jobsProductTypes`,
    // },
    projectRoute: true,
    channels: [
      "job/:jobNumber",
      "job/:jobNumber",
      "panel-revit/:jobNumber",
      "panel-plant/:jobNumber",
      "panel-yard/:jobNumber",
      "dates/holidays",
      "ifc-status/:jobNumber",
      "hold/:jobNumber",
      "comments",
      "mold-engineer-assignment/:jobNumber",
      "job-stats/panel-count/:jobNumber",
    ],
    enableAutoFind: false,
    onEnter: async ({ rootStore }: { rootStore: RootStore }) => {
      const panelStore = rootStore.panelStore as ServiceStore;
      const ifcStatusStore = rootStore.ifcStatusStore as ServiceStore;
      const routerStore = rootStore.routerStore;
      // const { find: findPanelPlant } = panelStore as ServiceStore;
      const jobNumber = routerStore?.params?.jobNumber;
      panelStore.find({
        query: {
          jobNumber: jobNumber,
        },
      });
      ifcStatusStore.find({
        query: {
          jobNumber: jobNumber,
        },
      });
      // .then((res) => {
      //   console.log('ifcStatusStore res', res);
      // });
    },
    // onEnter: async ({
    //   rootStore,
    //   params,
    // }: {
    //   rootStore: RootStore;
    //   params: RouteParamsType;
    // }) => {
    // const ifcTrackerStore = rootStore.ifcTrackerStore as IFCTrackerStore;
    // const jobStatsIfcStatusStore =
    //   rootStore.jobStatsIfcStatusStore as ServiceStore;
    // const { clearMultiSelectArray, multiSelectArray } = ifcTrackerStore;
    // const { get: getIfcStats } = jobStatsIfcStatusStore;
    // const { jobNumber } = toJS(params);
    // getIfcStats(jobNumber as number);
    // if (multiSelectArray && multiSelectArray.length > 0) {
    //   clearMultiSelectArray();
    // }
    //   const {
    //     ifcTrackerStore: { setStartDate, setEndDate },
    //     panelStore: { find: findPlantPanels },
    //   } = rootStore;
    //   const { jobNumber } = toJS(params);
    //   const { productType } = toJS(queryParams);

    //   let startDateTemp = `${utils.getYearFromDate(new Date())}-01-01`;
    //   let endDateTemp = `${utils.getYearFromDate(new Date())}-12-31`;

    //   const startCastingDateResponse = await findPlantPanels({
    //     query: {
    //       productType: productType,
    //       jobNumber: jobNumber,
    //       $limit: 1,
    //       $sort: { castingDate: 1 },
    //       castingDate: { $nin: ['1970-01-01'] },
    //     },
    //   });
    //   if (
    //     startCastingDateResponse &&
    //     startCastingDateResponse.data &&
    //     startCastingDateResponse.data.length
    //   ) {
    //     const smallCastingDateResponse = startCastingDateResponse.data[0];
    //     if (smallCastingDateResponse && smallCastingDateResponse.castingDate) {
    //       startDateTemp = smallCastingDateResponse.castingDate;
    //     }
    //   }
    //   setStartDate(startDateTemp);

    //   const endCastingResult = await findPlantPanels({
    //     query: {
    //       productType,
    //       jobNumber,
    //       $limit: 1,
    //       $sort: { castingDate: -1 },
    //       castingDate: { $nin: ['1970-01-01'] },
    //     },
    //   });
    //   if (
    //     endCastingResult &&
    //     endCastingResult.data &&
    //     endCastingResult.data.length
    //   ) {
    //     const largestCastingResult = endCastingResult.data[0];

    //     if (largestCastingResult && largestCastingResult.castingDate) {
    //       endDateTemp = largestCastingResult.castingDate;
    //     }
    //   }

    //   setEndDate(endDateTemp);
    // },
    // onParamsChange: async ({
    //   rootStore,
    //   params,
    //   queryParams,
    //   previousParams,
    //   previousQueryParams,
    // }) => {
    //   if (
    //     queryParams?.productType !== previousQueryParams.productType ||
    //     !utils.isSameJobNumber(params?.jobNumber, previousParams.jobNumber)
    //   ) {
    //     rootStore.routerStore.triggerEnterSideEffects();
    //   }
    // },
    // onExit: async ({ rootStore }) => {
    //   const {
    //     ifcTrackerStore: {
    //       clearMultiSelectArray,
    //       setScrollToColumn,
    //       setScrollToRow,
    //       setCurrentHighlightPanel,
    //     },
    //   } = rootStore;
    //   clearMultiSelectArray();
    //   setCurrentHighlightPanel({});
    //   setScrollToRow(0);
    //   setScrollToColumn(0);
    // },
  },
];

export default ifcTrackerRoute;
